import { render, staticRenderFns } from "./commonPicker.vue?vue&type=template&id=24c80f2e"
import script from "./commonPicker.vue?vue&type=script&lang=js"
export * from "./commonPicker.vue?vue&type=script&lang=js"
import style0 from "./commonPicker.vue?vue&type=style&index=0&id=24c80f2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports